import "@hotwired/turbo-rails"
import "@controllers/common/dropzone_controller"
import { setupI18n } from "@initializers/setup_i18n"

document.addEventListener("turbo:load", () => {
  setupI18n()
})

